import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import FooterLogo from 'components/footer-logo'
import { PropsWithChildren } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    overflowY: 'auto',
    minHeight: '100vh',
  },
}))

const Wrapper = ({ children }: PropsWithChildren) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {children}
      <FooterLogo />
    </div>
  )
}

export default Wrapper
